<template>
    <v-container>
       
        <QuizLoadScreen :value="loading" />

        <v-row v-if="!categorySelected" justify="center">
            <v-col cols="12" md="8">
                <h1>Escolha uma categoria:</h1>
                <!-- Caixa para inserir o nome do jogador -->
                <v-text-field
                    v-model="playerName"
                    label="Digite seu nome"
                    outlined
                    class="mb-4"></v-text-field>

                <v-select
                    v-model="selectedCategory"
                    :items="categories"
                    item-title="title"
                    item-value="id"
                    label="Categorias"
                    outlined></v-select>

                <v-btn
                    @click="selectCategory"
                    :disabled="!selectedCategory || !playerName"
                    color="primary"
                    class="mt-4">
                    Iniciar Quiz
                </v-btn>
                
                <span> &nbsp;</span>
                <v-btn
                    large
                    color="red"
                    class="mt-4"
                    @click="goToHome">
                    <v-icon left>mdi-help</v-icon>
                    Início
                </v-btn>
            </v-col>
        </v-row>

        <v-row v-else>
            <v-col cols="12" class="text-center mb-4">
                <section class="score">
                    <h2>
                        {{ playerName }} {{ win_count }} x {{ lose_count }}
                        {{ categoryName }}
                    </h2>
                </section>
                <!-- Barra de progresso -->
                <v-progress-linear
                    :value="progress"
                    height="20"
                    color="primary"
                    class="my-4">
                    {{ Math.round(progress) }}%
                </v-progress-linear>
            </v-col>

            <v-col
                cols="12"
                md="12"
                v-if="!quizFinished && question">
                <h1 v-html="question"></h1>
                <v-radio-group
                    inline
                    v-model="chosen_answer"
                    class="mt-4"
                    :disabled="answerSubmitted">
                    <v-radio
                        color="red"
                        v-for="(answer, index) in answers"
                        :key="index"
                        :label="answer"
                        :value="answer"></v-radio>
                </v-radio-group>

                <v-btn
                    v-if="!answerSubmitted"
                    @click="submitAnswer"
                    color="success"
                    class="mt-4">
                    Confirmar
                </v-btn>
            </v-col>

            <v-col
                cols="12"
                md="8"
                v-if="answerSubmitted && !quizFinished">
                <section class="result">
                    <template v-if="chosen_answer === correctAnswer">
                        <h4>✅ Parabéns, a resposta "{{ correctAnswer }}" está correta.</h4>
                    </template>
                    <template v-else>
                        <h4>❌ Que pena, a resposta está errada. A resposta correta é "{{ correctAnswer }}".</h4>
                    </template>
                    <v-btn
                        @click="getNewQuestion"
                        color="primary"
                        class="mt-4">Próxima pergunta</v-btn>
                    <v-btn
                        large
                        color="alert"
                        class="mt-4"
                        @click="goToHome">
                        <v-icon left>mdi-help-circle</v-icon>
                        Início
                    </v-btn>
                </section>
            </v-col>

            <v-col
                cols="12"
                md="8"
                v-if="quizFinished">
                <h1>🎉 Parabéns, você completou o quiz!</h1>
                <h3>Seu placar final foi: {{ playerName }} {{ win_count }} x {{ lose_count }} {{ categoryName }}</h3>
                <v-btn
                    @click="goToStart"
                    color="primary"
                    class="mt-4">Voltar ao início</v-btn>
                <v-btn
                    large
                    color="alert"
                    class="mt-4"
                    @click="goToHome">
                    <v-icon left>mdi-help</v-icon>
                    Início
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

  
  
<script>
import axios from "axios";
import QuizLoadScreen from "./QuizLoadScreen.vue";

export default {
    name: "App",
    components: {
        QuizLoadScreen,
    },
    data() {
        return {
            loading: false,

            playerName: "", // Nome do jogador
            chosen_answer: undefined,
            question: undefined,
            incorrectAnswers: [],
            correctAnswer: "",
            win_count: 0,
            lose_count: 0,
            answerSubmitted: false,
            categories: [],
            selectedCategory: null,
            categoryName: "", // Nome da categoria selecionada
            categorySelected: false,
            questions: [], // Todas as perguntas carregadas
            questionsAnswered: [], // Perguntas já respondidas
            quizFinished: false, // Indica se o quiz foi concluído
            token: "",
        };
    },
    computed: {
        answers() {
            const answers = [...this.incorrectAnswers];
            answers.splice(
                Math.floor(Math.random() * (answers.length + 1)),
                0,
                this.correctAnswer
            );
            return answers;
        },
        progress() {
            return (this.questionsAnswered.length / this.questions.length) * 100;
        },
    },
    methods: {

        goToHome() {
            this.$router.push("/");
        },

        async fetchToken() {
            try {
                const aToken = await axios.get(
                    "https://tryvia.ptr.red/api_token.php?command=request"
                );

                this.token = aToken.data.token;
                console.log("Token:", this.token);
            } catch (error) {
                console.error("Erro ao obter token:", error);
            }
        },

        async fetchCategories() {
            try {
                const response = await axios.get(
                    "https://tryvia.ptr.red/api_category.php"
                );

                this.categories = response.data.trivia_categories.map((category) => ({
                    id: category.id,
                    title: category.name,
                }));
                console.log("Categorias mapeadas:", JSON.stringify(this.categories, null, 2));
            } catch (error) {
                console.error("Erro ao obter categorias:", error);
            }
        },
        async fetchQuestions() {
            try {
                this.loading = true; // Ativa a tela de carregamento

                const resp = await axios.get(
                    `https://tryvia.ptr.red/api.php?amount=10&category=${this.selectedCategory}&token=${this.token}`
                );

                this.questions = resp.data.results; // Armazena todas as perguntas
                this.getNewQuestion();
            } catch (error) {
                console.error("Erro ao obter as perguntas:", error);
            } finally {
                this.loading = false; // Desativa a tela de carregamento
            }
        },
        selectCategory() {
            this.categorySelected = true;
            const category = this.categories.find(
                (cat) => cat.id === this.selectedCategory
            );
            this.categoryName = category ? category.title : "Categoria";
            this.fetchQuestions();
        },
        submitAnswer() {
            if (!this.chosen_answer) {
                alert("Escolha uma das opções");
            } else {
                this.answerSubmitted = true;
                if (this.chosen_answer === this.correctAnswer) {
                    this.win_count++;
                } else {
                    this.lose_count++;
                }
                this.questionsAnswered.push(this.question); // Adiciona a pergunta ao array de respondidas
                if (this.questionsAnswered.length === this.questions.length) {
                    this.quizFinished = true; // Finaliza o quiz
                }
            }
        },
        getNewQuestion() {
            this.chosen_answer = undefined;
            this.answerSubmitted = false;

            if (this.questionsAnswered.length < this.questions.length) {
                const remainingQuestions = this.questions.filter(
                    (q) => !this.questionsAnswered.includes(q.question)
                );
                const nextQuestion = remainingQuestions[0]; // Pega a próxima pergunta

                if (nextQuestion) {
                    this.question = nextQuestion.question; // Pergunta
                    this.correctAnswer = nextQuestion.correct_answer; // Resposta correta
                    this.incorrectAnswers = nextQuestion.incorrect_answers; // Respostas incorretas

                    // Combina respostas corretas e incorretas, embaralha e define a lista de respostas
                    const allAnswers = [...this.incorrectAnswers];
                    allAnswers.splice(
                        Math.floor(Math.random() * (allAnswers.length + 1)),
                        0,
                        this.correctAnswer
                    );
                    this.answers = allAnswers;
                }
            }
        },
        goToStart() {
            // Reinicia o quiz e volta para a seleção de categoria
            this.categorySelected = false;
            this.questionsAnswered = [];
            this.quizFinished = false;
            this.win_count = 0;
            this.lose_count = 0;
            this.selectedCategory = null;
            this.playerName = "";
        },
    },
    created() {
        this.fetchToken();
        this.fetchCategories();

    },
};
</script>
  
  
<style scoped>
.score {
    border-bottom: 1px solid black;
    padding: 24px;
    font-size: 24px;
    /* Aumentado para maior destaque */
    font-weight: bold;
}
</style>
